module.exports = ":host {\n  display: flex;\n  justify-content: center; }\n\n.inner-margin {\n  margin-left: 10px; }\n\n.omnis-label {\n  min-width: 150px; }\n"